import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { ResponseData } from "./common"
import { ReviewResponseType } from "./favorite/types"

interface PropertyReviewsRequestData {
  propertyId: string
  pageNo?: number
  noOfRecords?: number
  avoidClientSideAuth?: boolean
}

export interface PropertyReview {
  pmc_id: string
  unit_id: string
  title: string | null
  comment: string
  rating: number
  review_type: string
  review_source_secondary: string | null
  review_source: string | null
  is_hide: boolean
  reviewer_id: string | null
  reviewer_name: string | null
  booking_number: string | null
  review_reported_date: number | null
  reported_review_accepted_date: number | null
  reported_review_rejected_date: number | null
  response?: ReviewResponseType[] | null
  is_read: boolean | null
  created_dt: number
  updated_dt: number | null
  publish_dt: number
}

// API response "data" field
export interface PropertyReviewData {
  content: PropertyReview[]
  totalElements: number
}

export interface PropertyReviewsRequest extends Partial<AxiosRequestConfig> {
  params: PropertyReviewsRequestData
}

export interface PropertyReviewsResponseData extends ResponseData {
  data: PropertyReviewData
}

export interface PropertyReviewsResponse extends AxiosResponse {
  data: PropertyReviewsResponseData
}

export function getPropertyReviewsApi(
  {
    params,
    method = "get",
    url = `/property/propertyId/reviews/${params.propertyId}`,
    ...config
  }: PropertyReviewsRequest,
  axiosInstance: AxiosInstance,
): Promise<PropertyReviewsResponse> {
  return axiosInstance({
    ...(params.avoidClientSideAuth
      ? {
          data: {
            avoidClientSideAuth: true,
          },
        }
      : {}),
    method,
    url,
    params: {
      pageNo: params.pageNo ?? 0,
      noOfRecords: params.noOfRecords ?? 20,
    },
    ...config,
  }) as Promise<PropertyReviewsResponse>
}
